import React, { useState } from 'react';
import styles from './DocumentCompare.module.scss';
import { ServiceOptions } from 'app/components';
import { DocumentSelector } from './DocumentSelector';
import { ComparisonHistory } from './ComparisonHistory';
import { ComparisonResult } from './ComparisonResult';
import { Button } from '@zurich-primitives/button';
import { ReactComponent as PlusIcon } from 'app/assets/Icons/Plus.svg';
import { ReactComponent as HistoryIcon } from 'app/assets/Icons/History.svg';

export const DocumentCompareV2: React.FC = () => {
  const [currentView, setCurrentView] = useState<
    'selector' | 'history' | 'result'
  >('selector');
  const [selectedComparisonId, setSelectedComparisonId] = useState<string>('');
  const [isComparisonProcessing, setIsComparisonProcessing] =
    useState<boolean>(false);
  const [comparisonStreamReader, setComparisonStreamReader] = useState<
    ReadableStreamDefaultReader<Uint8Array> | undefined
  >(undefined);

  const getButtonText = (): string => {
    switch (currentView) {
      case 'result':
      case 'history':
        return 'New Comparison';
      case 'selector':
        return 'Comparison History';
      default:
        return 'New Comparison';
    }
  };

  const getButtonIcon = (): JSX.Element => {
    switch (currentView) {
      case 'result':
      case 'history':
        return <PlusIcon />;
      case 'selector':
        return <HistoryIcon />;
      default:
        return <PlusIcon />;
    }
  };

  const handleButtonClick = (): void => {
    switch (currentView) {
      case 'result':
      case 'history':
        setCurrentView('selector');
        break;
      case 'selector':
        setCurrentView('history');
        break;
    }
  };

  const renderCurrentView = (): JSX.Element => {
    switch (currentView) {
      case 'selector':
        return <DocumentSelector onComparisonCreated={onComparisonCreated} />;
      case 'history':
        return (
          <ComparisonHistory
            onViewReport={(comparisonId) => {
              handleViewReport(comparisonId);
            }}
          />
        );
      case 'result':
        return (
          <ComparisonResult
            comparisonId={selectedComparisonId}
            isProcessing={isComparisonProcessing}
            streamReader={comparisonStreamReader}
            onComparisonFailure={() => setCurrentView('selector')}
          />
        );
      default:
        return <DocumentSelector onComparisonCreated={onComparisonCreated} />;
    }
  };

  const handleViewReport = (comparisonId: string): void => {
    setSelectedComparisonId(comparisonId);
    setIsComparisonProcessing(false);
    setCurrentView('result');
  };

  const onComparisonCreated = (
    comparisonId: string,
    streamReader: ReadableStreamDefaultReader<Uint8Array>
  ): void => {
    setSelectedComparisonId(comparisonId);
    setIsComparisonProcessing(true);
    setComparisonStreamReader(streamReader);
    console.log('Comparison created with ID:', comparisonId);
    setCurrentView('result');
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <ServiceOptions />
        <Button
          className={styles.button}
          variant="secondary"
          size="small"
          onClick={handleButtonClick}
          style={{
            alignSelf: currentView === 'result' ? 'flex-start' : 'flex-end'
          }}
        >
          <Button.Icon>{getButtonIcon()}</Button.Icon>
          <Button.Label>{getButtonText()}</Button.Label>
        </Button>
      </div>
      {renderCurrentView()}
    </div>
  );
};
